import { ServerElement } from '@swagger-api/apidom-ns-openapi-3-0';
class Server extends ServerElement {}
export default Server;